import { ButtonGroup } from '@mui/material';
import Button from '@mui/material/Button';
import { useGetPatientInfo } from 'modules/report/hooks/usePatientInfo';
import styled from 'styled-components';

export const HypoButton = ({ active, setActive, patientId }) => {
  const { data: patientInfo } = useGetPatientInfo(patientId);
  const { isPregnant } = patientInfo || {};

  const totalClick = () => {
    setActive('total');
  };
  const level2Click = () => {
    setActive('level');
  };

  return (
    <StyledHypoButtonGroup dir="ltr" variant="text" activeBtn={active}>
      <Button className="hypo-button total-btn-isActive" onClick={totalClick}>
        Total Hypos (&#60;{isPregnant ? 60 : 70} mg/dl)
      </Button>
      <Button className="hypo-button level-btn-isActive " onClick={level2Click}>
        Level 2 Hypos (&#60;54 mg/dl)
      </Button>
    </StyledHypoButtonGroup>
  );
};

const StyledHypoButtonGroup = styled(ButtonGroup)`
  background: #f5f5f5 !important;
  border-radius: 50px !important;
  margin: auto;
  border: none;
  .hypo-button {
    font-size: 12px;
    font-family: 'dana-bold';
    line-height: 19px;
    letter-spacing: 0px;
    text-align: center;
    border-radius: inherit !important;
    margin: 4px;
    text-transform: inherit;
    border: none !important ;
  }
  .total-btn-isActive {
    background: ${({ activeBtn }) =>
      activeBtn === 'total' ? '#753CBE26 !important' : 'transparent'};
    color: ${({ activeBtn }) =>
      activeBtn === 'total' ? '#6F4D9F' : '#4D4D4E'};
  }
  .level-btn-isActive {
    background: ${({ activeBtn }) =>
      activeBtn === 'level' ? '#753CBE26 !important' : 'transparent'};
    color: ${({ activeBtn }) =>
      activeBtn === 'level' ? '#6F4D9F' : '#4D4D4E'};
  }
  @media screen and (min-width: 1024px) {
    background: #f5f5f5 !important;
    border-radius: 24px !important;
    margin: auto;
    border: none;
    .hypo-button {
      border-radius: 16px !important;
      padding: 21px 23px;
      border-radius: inherit !important;
      margin: 0;
      font-size: 24px;
    }
  }
`;
